import React, { useState, useEffect } from "react";
import { createGrammarTopic, updateGrammarTopic } from "./adminGrammarService";

const GrammarTopicForm = ({ topic, onSaved, onCancel }) => {
 const isEdit = !!topic;
 const [form, setForm] = useState({ title: "", description: "", icon: "", sortOrder: "" });
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 if (topic) {
 setForm({
 title: topic.title || "",
 description: topic.description || "",
 icon: topic.icon || "",
 sortOrder: topic.sortOrder ?? "",
 });
 }
 }, [topic]);

 const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

 const handleSubmit = async () => {
 if (!form.title || !form.description) {
 alert("Title and Description are required");
 return;
 }
 const payload = {
 ...form,
 sortOrder: form.sortOrder !== "" ? Number(form.sortOrder) : null,
 };
 setLoading(true);
 const res = isEdit
 ? await updateGrammarTopic(topic.id, payload)
 : await createGrammarTopic(payload);
 if (res.status === 200 || res.status === 201) {
 onSaved();
 } else {
 alert(res.message || "Operation failed");
 }
 setLoading(false);
 };

 return (
 <div className="modal-overlay">
 <div className="modal-content">
 <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
 <h2>{isEdit ? "Edit" : "Create"} Grammar Topic</h2>

 <div className="form-group">
 <label>Icon (emoji)</label>
 <input name="icon" placeholder="📝" value={form.icon} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Title *</label>
 <input name="title" placeholder="e.g. Parts of Speech" value={form.title} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Description *</label>
 <textarea name="description" placeholder="Brief description..." value={form.description} onChange={handleChange} rows={3} />
 </div>

 <div className="form-group">
 <label>Sort Order</label>
 <input name="sortOrder" type="number" placeholder="e.g. 1" value={form.sortOrder} onChange={handleChange} />
 </div>

 <div className="form-actions">
 <button onClick={handleSubmit} disabled={loading}>
 {loading ? "Saving..." : isEdit ? "Update" : "Create"}
 </button>
 <button onClick={onCancel} disabled={loading}>Cancel</button>
 </div>
 </div>
 </div>
 </div>
 );
};

export default GrammarTopicForm;
